import { Card } from 'react-bootstrap';
import Payments from './partials/Payments';
import ClientPayments from './partials/ClientPayments';

function Index(props) {

    return (
        <>
            <Card className="mb-3">
                <Card.Header>
                    Плащания по сметката
                </Card.Header>
                <Card.Body>
                    <Payments
                        id={props.id}
                        showPayment={props.showPayment}
                    />
                </Card.Body>
            </Card>

            <Card className="">
                <Card.Header>
                    Движения по клиентски портфейл
                </Card.Header>
                <Card.Body>
                    <ClientPayments
                        id={props.id}
                    />
                </Card.Body>
            </Card>
        </>
    )
}

export default Index;